import { Button } from '@cian/ui-kit';
import { IconActionCompareAdd16, IconActionCompareAdded16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import {
  ADD_TO_COMPARE_LABEL,
  ADD_TO_COMPARE_TEXT,
  COMPARE_BUTTON_DATA_MARK,
  REMOVE_FROM_COMPARE_LABEL,
  REMOVE_FROM_COMPARE_TEXT,
} from './constants';

interface ICompareButtonControlProps {
  hideText?: boolean;
  isHeader?: boolean;
  isAdded: boolean;
  onClick(): void;
}

export function CompareButtonControl({
  hideText = false,
  isHeader = false,
  isAdded,
  onClick,
}: ICompareButtonControlProps) {
  const iconColor = isHeader ? 'icon-primary-default' : 'icon-main-default';
  const theme = isHeader ? 'stroke_secondary' : 'fill_white_primary';

  return (
    <Button
      beforeIcon={
        isAdded ? <IconActionCompareAdded16 color={iconColor} /> : <IconActionCompareAdd16 color={iconColor} />
      }
      theme={theme}
      size="M"
      onClick={onClick}
      data-mark={COMPARE_BUTTON_DATA_MARK}
      data-testid="NewbuildingCompareButton"
      aria-label={isAdded ? REMOVE_FROM_COMPARE_LABEL : ADD_TO_COMPARE_LABEL}
    >
      {hideText ? '' : isAdded ? REMOVE_FROM_COMPARE_TEXT : ADD_TO_COMPARE_TEXT}
    </Button>
  );
}
